<div class="toast-host" aria-live="polite" aria-relevant="additions removals">
  @for (toast of toasts(); track toast.id) {
  <div
    class="toast"
    [class.is-leaving]="isLeaving(toast.id)"
    [attr.data-variant]="toast.variant"
    role="status"
  >
    @if (toast.title) {
    <h4>{{ toast.title }}</h4>
    }
    <h5>{{ toast.message }}</h5>

    <button
      type="button"
      [ds-variant]="'close-contrast'"
      (click)="dismiss(toast.id)"
    ></button>
  </div>
  }
</div>
